import { http } from '@/http/axios.js'

// 菜单列表
export function getMenusList(params) {
  return http({
    url: '/api/admin/rbac/menu/tree',
    method: 'GET',
    params
  })
}

// 菜单树
export function getMenusTree(params) {
  return http({
    url: '/api/admin/rbac/menu/tree',
    method: 'GET',
    params
  })
}
export function getMenuDetail(id) {
  return http({
    url: `/api/admin/rbac/menu/detail`,
    method: 'GET',
    params: { id }
  })
}

export function editMenu(data) {
  return http({
    url: `/api/admin/rbac/menu/edit`,
    method: 'post',
    data
  })
}

export function addMenu(data) {
  return http({
    url: `/api/admin/rbac/menu/add`,
    method: 'POST',
    data
  })
}

export function delMenu(id) {
  return http({
    url: `/api/admin/rbac/menu/del`,
    method: 'post',
    data: { id }
  })
}

// 模块列表
export function getModuleList() {
  return http({
    url: `/auth/menu/module/list`,
    method: 'get'
  })
}
